import { thumbHashToDataURL } from 'thumbhash';

export const toPlaceholderImage = (hashString: string) => {
  const binaryString = atob(hashString);
  const len = binaryString.length;
  const uintArray = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    uintArray[i] = binaryString.charCodeAt(i);
  }
  const placeholderImage = thumbHashToDataURL(uintArray);
  return placeholderImage;
};
